import { paletteActions } from './actions-const';

export function setPalette(palette) {
  return {
    type: paletteActions.SET_PALETTE,
    palette,
  };
}
